var alignment_default = {
  "alignLeft": "SPF5D",
  "textWrapNowrap": "SdOi9",
  "alignRight": "lfU9R",
  "alignCenter": "aEZ2c",
  "sizeFullWidth": "qQ0jz",
  "renderedInTable": "YPlk8",
  "sizeOriginal": "K2Iay",
  "sizeContent": "bme3H",
  "sizeSmall": "-QvXu",
  "sizeSmallCenter": "bwrlr",
  "flex": "_87ygR",
  "LEFT": "KHfOY",
  "CENTER": "qnnYw",
  "RIGHT": "dzYUV",
  "AUTO": "Fyqp4",
  "JUSTIFY": "VmPlf"
};
export {
  alignment_default as default
};
//# sourceMappingURL=alignment-scss.js.map
